import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { BankDetailService } from 'src/app/services/bank-details.service';
import { ChallanService } from 'src/app/services/challan-services.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { FarmersApplicationService } from 'src/app/services/farmers-application.service';

@Component({
  selector: 'app-solar-challan',
  templateUrl: './solar-challan.component.html',
  styleUrls: ['./solar-challan.component.scss']
})
export class SolarChallanComponent implements OnInit {
  public farmerId: any;
  public farmerMobile: any;
  public farmerAppDetails: any;
  public selectedFarmerDeatils: any;
  public selectedAppId: any;

  public filteredAppId: any;
  public dataRecieved: boolean = false;
  public challanData: any;

  public currentDate: Date;
  public solarApplicatonForm: FormGroup;

  public pumpCapacityList: any;
  public solarMasterData: any = [];
  public primarySolarVendorList = [];
  public selectedPrimarySolarVendor: any;
  public selectedSecondarySolarVendor: any;
  public selectedSecondarySolarVendorId: any;
  public secondarySolarVendorList = [];

  public isSubmittedWaterCourseFrom: boolean = false;
  public isSubmittedPondApplicatonForm: boolean = false;
  public isSubmittedSolarApplicatonFrom: boolean = false;

  public landIDList: any;
  public solarPumpDetail: any = null;

  public isUpdateButtonDisabled = false;



  constructor(
    public dashboard: DashboardService,
    public productService: BankDetailService,
    private challanMIService: ChallanService,
    private messageService: MessageService,
    private activityRecordService: ActivityRecordService,
    private loader: AppLoaderService,
    private farmerAppSer: FarmersApplicationService,
    private _fb: FormBuilder,
    private cryptoJsService: CryptoJsService
  ) { }

  ngOnInit(): void {
    const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    const farmerConfData = new Map(encData);
    this.farmerMobile = farmerConfData.get('farmerPh');

    let farmerData = farmerConfData.get('farmerDetails');

    this.farmerId = farmerConfData.get('Farmer_Id_');
    // this.farmerMobileNo = farmerConfData.get('farmerPh');

    this.getApplicationIdsForSolarChallan(this.farmerId);

    this.solarApplicatonForm = this._fb.group({
      controlType: ['', Validators.required],
      pump: ['', Validators.required],
      pumpType: ['', Validators.required],
      pumpCapacity: ['', Validators.required],
      primaryVendor: ['', Validators.required],
      secondaryVendor: [''],
      farmerShare: [''],
      solarId: ['', Validators.required],
      landId: ['', Validators.required],
    });

    this.getSolarMaster();
  }

  get solarApplicatonFormControls() {
    return this.solarApplicatonForm.controls;
  }

  onSolarLandIdSelected(event) { }

  onVendorSelect(event) { }

  validateAndGetSolarVendors() {
    if (
      this.solarApplicatonForm.controls.controlType.value &&
      this.solarApplicatonForm.controls.pump.value &&
      this.solarApplicatonForm.controls.pumpType.value
    ) {
      this.getPumpCapacityList(this.solarApplicatonForm.controls.controlType.value, this.solarApplicatonForm.controls.pumpType.value,
        this.solarApplicatonForm.controls.pump.value);
    }

    if (
      this.solarApplicatonForm.controls.controlType.value &&
      this.solarApplicatonForm.controls.pump.value &&
      this.solarApplicatonForm.controls.pumpType.value &&
      this.solarApplicatonForm.controls.pumpCapacity.value
    ) {
      this.getPrimarySolarVendors();
    }
  }

  getPumpCapacityList(PumpContType, PumpCategory, PumpType) {
    this.loader.start();
    this.farmerAppSer
      .getPumpCapacityList(PumpContType, PumpCategory, PumpType)
      .subscribe({
        next: (data) => {
          this.loader.close();
          this.pumpCapacityList = data;
        },
        error: (err) => {
          this.loader.close();
        },
      });
  }

  getPrimarySolarVendors() {
    this.primarySolarVendorList = [];

    let solarMasteredFilteredData = this.getFarmerShare();
    if (solarMasteredFilteredData) {
      this.solarApplicatonForm.patchValue({
        farmerShare: solarMasteredFilteredData.Farmers_Share,
      });
      this.solarApplicatonForm.patchValue({
        solarId: solarMasteredFilteredData.Solar_ID,
      });

      this.loader.start();
      this.farmerAppSer
        .getPrimarySolarVendors(solarMasteredFilteredData.Solar_ID)
        .subscribe({
          next: (data) => {
            this.loader.close();
            if (data) {
              this.primarySolarVendorList = data;
              if (this.selectedAppId) {
                this.onPrimarySolarVendorChange({
                  value: this.selectedPrimarySolarVendor,
                });
              }

            }
          },
          error: (err) => {
            this.loader.close();
          },
        });
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Data error! Solar ID Not Found For selected Combination',
      });
    }
  }

  onPrimarySolarVendorChange(event) {
    this.selectedPrimarySolarVendor = event.value;
    let solarMasteredFilteredData = this.getFarmerShare();
    let selectedPrimaryVendor = this.primarySolarVendorList.filter(vendor => {
      return vendor.Primary_Vendor === event.value
    })
    this.secondarySolarVendorList = [];
    this.selectedSecondarySolarVendor = null;
    if (selectedPrimaryVendor.length) {
      this.getSecondarySolarVendors(selectedPrimaryVendor[0].pid);
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'PID value is unknown for Selcted Primary Vendor, Hence Secondary Vendor is not known',
      });
      return;
    }
  }

  getSecondarySolarVendors(solarId: any) {
    this.loader.start();
    this.farmerAppSer.getSecondarySolarVendors(solarId).subscribe({
      next: (data) => {
        this.loader.close();
        if (data) {
          this.secondarySolarVendorList = data;
          this.selectedSecondarySolarVendor = this.solarPumpDetail?.Secondary_Vendor;
          this.selectedSecondarySolarVendorId = this.solarPumpDetail?.Solar_Vendor_Secondry_ID;
        }
      },
      error: (err) => {
        this.loader.close();
      },
    });
  }

  onCapacityOfPumpSelected(event) {
    if (!this.solarApplicatonForm.controls.controlType.value) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Data error! SOLAR FORM - controlType Cant be Empty',
      });
      return;
    } else if (!this.solarApplicatonForm.controls.pump.value) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Data error! SOLAR FORM - pump Cant be Empty',
      });
      return;
    } else if (!this.solarApplicatonForm.controls.pumpType.value) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Data error! SOLAR FORM - pumpType Cant be Empty',
      });
      return;
    } else if (!this.solarApplicatonForm.controls.pumpCapacity.value) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Data error! SOLAR FORM - pumpCapacity Cant be Empty',
      });
      return;
    } else if (!this.solarApplicatonForm.controls.landId.value) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Data error! SOLAR FORM - landId Cant be Empty',
      });
    }

    this.validateAndGetSolarVendors();
  }


  onSecondarySolarVendorChange(event) {
    this.selectedSecondarySolarVendor = event.value;
    let selectedSolarVendor = this.secondarySolarVendorList.filter((x) => {
      return x.Secondary_Vendor === this.selectedSecondarySolarVendor;
    });
    this.selectedSecondarySolarVendorId = selectedSolarVendor[0].sid;
  }

  getSolarMaster() {
    this.loader.start();
    this.farmerAppSer.getSolarMaster().subscribe({
      next: (data) => {
        this.loader.close();
        if (data) {
          this.solarMasterData = data;
        }
      },
      error: (err) => {
        this.loader.close();
      },
    });
  }


  getFarmerShare() {
    return this.solarMasterData.filter(
      (d: any) =>
        d.Pump_Controler_Type ===
        this.solarApplicatonForm.value['controlType'] &&
        d.Pump_Capacity === this.solarApplicatonForm.value['pumpCapacity'] &&
        d.Pump_Category === this.solarApplicatonForm.value['pumpType'] &&
        d.Pump_Type === this.solarApplicatonForm.value['pump']
    )[0];
  }

  getApplicationIdsForSolarChallan(farmerId) {
    let mobile = this.farmerMobile;

    let reqBody = {
      FarmerId: farmerId
    }

    let reqBodyAfterEncypt = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
    }

    this.loader.start();
    this.challanMIService
      .getApplicationIdsForSolarChallan(reqBodyAfterEncypt)
      .pipe(first())
      .subscribe({
        next: (resData) => {
          let res = JSON.parse(this.cryptoJsService.DecryptToken(resData.data));
          // this.activityRecordService.activityRecord(mobile, 'Solar Challan', farmerId, new Date(), 'Success');

          this.farmerAppDetails = res;
          this.loader.close();
        },
        error: (err) => {
          // this.activityRecordService.activityRecord(mobile, 'Solar Challan', farmerId, new Date(), err);
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  onSelectAppId() {
    this.isUpdateButtonDisabled = false;
    this.selectedAppId = this.selectedFarmerDeatils;

    this.getSolarChallan(this.selectedAppId);
    this.getFarmerSolarDetails(this.selectedAppId);
  }

  getSolarChallan(id) {
    let mobile = this.farmerMobile;
    this.loader.start();
    this.challanMIService
      .getSolarChallan(id)
      .pipe(first())
      .subscribe({
        next: (data) => {
          // this.activityRecordService.activityRecord(mobile, 'Solar Challan Details', id, new Date(), 'Success');

          this.challanData = data;
          this.loader.close();
          this.currentDate = new Date();
          this.dataRecieved = true;
        },
        error: (err) => {
          // this.activityRecordService.activityRecord(mobile, 'Solar Challan Details', id, new Date(), err);
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! Challan not loaded.',
          });
        },
      });
  }

  getFarmerSolarDetails(id) {
    let mobile = this.farmerMobile;
    this.loader.start();
    this.challanMIService
      .getFarmerSolarDetails(id)
      .pipe(first())
      .subscribe({
        next: (data) => {
          // this.activityRecordService.activityRecord(mobile, 'Farmer Solar Details', id, new Date(), 'Success');
          this.loader.close();
          this.solarPumpDetail = data?.Table[0];
          if (this.solarPumpDetail) {
            let val = this.solarPumpDetail;
            this.landIDList = [val?.LandDetails]
            this.solarApplicatonForm.controls.landId.setValue(val?.LandDetails);
            this.solarApplicatonForm.controls.controlType.setValue(val?.Pump_Controler_Type);
            this.solarApplicatonForm.controls.pump.setValue(val?.Pump_Type);
            this.solarApplicatonForm.controls.pumpType.setValue(val?.Pump_Category);
            this.solarApplicatonForm.controls.pumpCapacity.setValue(val?.Pump_Capacity);
            this.validateAndGetSolarVendors();

            this.selectedPrimarySolarVendor = val?.Primary_Vendor;
            this.selectedSecondarySolarVendor = val?.Secondary_Vendor;

            this.solarApplicatonForm.controls.farmerShare.setValue(val?.Farmers_Share);
          }
        },
        error: (err) => {
          // this.activityRecordService.activityRecord(mobile, 'Farmer Solar Details', id, new Date(), err);
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! Farmer Solar Details.',
          });
        },
      });
  }

  onSolarFormUpdate(){
    if(this.solarApplicatonForm.valid){
      if(this.selectedPrimarySolarVendor == undefined || this.selectedSecondarySolarVendor == undefined){
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail: 'Fill the Vendor Details properly',
        });
        return;
      }
      let selectedPrimarySolarVendor = this.primarySolarVendorList.filter(
        (x) => {
          return x.Primary_Vendor === this.selectedPrimarySolarVendor;
        }
      );
      let selectedSecondarySolarVendor = this.secondarySolarVendorList.filter(
        (x) => {
          return x.Secondary_Vendor === this.selectedSecondarySolarVendor;
        }
      );
      let selectedSolarId = this.pumpCapacityList.filter(
        (x) => {
          return x.Pump_Capacity === this.solarApplicatonForm.value.pumpCapacity;
        }
      );

      const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
      const farmerConfData = new Map(encData);
      let ipAddress =  farmerConfData.get('ipAddress') ? farmerConfData.get('ipAddress') : ''
  
      let reqBody = {
        appId: this.solarPumpDetail?.APP_ID,
        solarId: selectedSolarId[0]?.Solar_ID,
        solarVendorId: selectedPrimarySolarVendor[0]?.pid,
        solarVendorSecId: selectedSecondarySolarVendor[0]?.sid,
        netWork_Id: ipAddress,
        terminal_Id: ipAddress
      }
      this.updateFarmerSolarDetails(reqBody);
    }else{
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Fill the deatils properly',
      });
    }

    
  }

  updateFarmerSolarDetails(reqBody) {
    this.loader.start();
    this.farmerAppSer
      .updateFarmerSolarDetails(reqBody)
      .subscribe({
        next: (data) => {
          this.loader.close();
          this.getSolarChallan(this.selectedAppId);
          this.isUpdateButtonDisabled = true;
          this.messageService.add({
            severity: 'success',
            summary: 'Success Message',
            detail: 'Farmer Solar Details Updated Successfully',
          });
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  onPrint(divName) {
    document.body.style.visibility = "hidden";
    document.getElementById(divName).style.visibility = 'visible'
    document.getElementById('select_app_solor_card').style.display = 'none'
    window.print();
    document.getElementById('select_app_solor_card').style.display = 'block'
    document.body.style.visibility = "visible";
  }
}
